import store from '@/store/index.js';

class AnalyticsService {
  sendEvent (gtag, action, category, label, value = null) {
    if ((gtag || null) === null) return;
    var config = { event_category: category, event_label: label, value: value };

    if ((store || null) !== null && (store.state || null) !== null && (store.getters['auth/userProfile'] || null) !== null) {
      // Add agencyId custom dimension to the event.
      config.agencyId = store.getters['auth/userProfile'].agencyId;
      config.userInitials = store.getters['auth/userProfile'].hsUserName;
    }

    gtag.event(action, config);
  }

  sendEventFromUser (gtag, action, category, label, agencyId, username, value = null) {
    if ((gtag || null) === null) return;

    var config = {
      event_category: category,
      event_label: label,
      value: value,
      agencyId: agencyId,
      userInitials: username
    };

    gtag.event(action, config);
  }

  // Sets a constant that will be supplied with all page views and events.
  // Changing this while running will cause all previous events to update to the new value.
  set (gtag, key, value) {
    if ((gtag || null) === null) return;

    var config = {};
    config[key] = value;
    gtag.set(config);
  }

  // Maps a custom dimension or metric to an event property.
  // Example keys: 'dimension1' or 'metric1'
  // The number is the index provided when after creating the dimension/metric in GA. )
  customMap (gtag, config) {
    if ((gtag || null) === null) return;
    gtag.customMap(config);
  }
}

var x = new AnalyticsService();
export default x;
